// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import casePeripheral from './metaData/casePeripheral'
export default {
  state: casePeripheral,
  actions
}
